
const digest = 'ef015fd81c2967f20c7721c2e395dec479543a090c7b797331fe1fdb7e3b289d';
const classes = {"wrapper":"_wrapper_5rqhl_1","sections":"_sections_5rqhl_8"};
const css = `._wrapper_5rqhl_1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
}

._sections_5rqhl_8 {
  display: flex;
  flex-direction: row;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  